import { ShieldCheck } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Button } from '../../components/Button';
import { useToast } from '../../components/Toast';
import { useAuth } from '../auth/AuthProvider';

/**
 * Shown while a super administrator works inside a tenant entered from the
 * platform (ADR-028), so it is never mistaken for the platform itself.
 */
export function EnteredTenantBanner() {
  const { session, leaveTenant } = useAuth();
  const { notify } = useToast();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!session?.user.entered_from_platform) return null;

  const leave = async () => {
    setBusy(true);
    try {
      await leaveTenant();
      // The platform's home (the overview); the operation screen left open
      // would send there anyway.
      void navigate('/', { replace: true });
    } catch {
      setBusy(false);
      notify('Não foi possível voltar à plataforma. Tente novamente.', 'error');
    }
  };

  return (
    <div
      role="region"
      aria-label="Acesso de Super administrador"
      className="flex shrink-0 items-center gap-3 border-b border-warn/30 bg-warn-soft px-4 py-1.5 text-[13px] text-fg"
    >
      <ShieldCheck aria-hidden="true" className="size-4 shrink-0 text-warn" />
      <p className="min-w-0 flex-1 truncate">
        Você está em <strong className="font-semibold">{session.tenant.name}</strong> como Super
        administrador. O que fizer aqui fica registrado só na auditoria da plataforma.
      </p>
      <Button className="h-7 shrink-0" disabled={busy} onClick={() => void leave()}>
        {busy ? 'Voltando…' : 'Voltar à plataforma'}
      </Button>
    </div>
  );
}
